// extracted by mini-css-extract-plugin
export default {"image":"l3-z","loaded":"m3-z"};